import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";

export default {
	name: "payslipDetail",
	components: {
		MainLayout,
		Loading,
	},

	data() {
		return {
			payslipData: {},
			details: [],
			isLoading: false,
			config: CONFIG,
			noDataMsg: CONFIG.NO_DATA_FOUND,
		};
	},

	computed: {
		breadcrumbRouteName() {
			return this.$route.meta.backRoute || "payslipList";
		},
		breadcrumbLabel() {
			return this.$route.meta.breadcrumbLabel || "Payslip History";
		},
		detailTitle() {
			return this.$route.meta.title || "Payslip Detail";
		},
	},

	methods: {
		/**
		 * get payslip detail
		 */
		getDetail() {
			this.isLoading = true;
			const basePath =
				this.$route.name === "myPayslipDetail"
					? "my/payslip"
					: "payslip";
			axios
				.get(`${basePath}/${this.$route.params.empPaymentId}/detail`)
				.then((res) => {
					this.payslipData = res.data || {};
					this.isLoading = false;
				})
				.catch((error) => {
					this.isLoading = false;
					if (error.response && error.response.status === 401) {
						this.$store.commit("logout");
						window.location.replace("login");
					}
				});
		},

		goBack() {
			this.$router.push({ name: this.breadcrumbRouteName });
		},
	},

	mounted() {
		this.getDetail();
	},
};
